/* @flow */

import { partialRight } from 'ramda';
import { assertObject, assertString } from '@braindate/util/lib/assert';

import type { State } from 'src/shared/core/type/reduxTypes';

const getValue = (state: State, key: string): any => {
  assertObject(state, 'state');
  assertString(key, 'key');

  return state.ui.checkIn[key];
};

const getNestedValue = (state: State, props: Object, key: string): any => {
  assertObject(props, 'props');

  return getValue(state, key)[props.id];
};

export const isCheckInAnimationRunning: (
  state: State,
  props: Object,
) => ?boolean = partialRight(getNestedValue, ['isAnimationRunning']);

export const isCheckInIsFetching: (state: State, props: Object) => ?boolean =
  partialRight(getNestedValue, ['isFetching']);
